/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationClinicalStaffAliases {
  AVATAR_DOCTOR = 'avatar-doctor',
  BUTTON_ADD = 'button-add',
  BUTTON_ADD_DOCTOR = 'button-add-doctor',
  CHECKBOX_0 = 'checkbox-0',
  DECK_CLINICAL_STAFF = 'deck-clinical-staff',
  FETCH_CBO = 'fetch-cbo',
  FETCH_CLINICAL_STAFF = 'fetch-clinical-staff',
  FETCH_COUNSEL = 'fetch-counsel',
  FETCH_FIELD_OF_WORK = 'fetch-field-of-work',
  FETCH_FIELD_OF_WORK_LIST = 'fetch-field-of-work-list',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FETCH_SPECIALTY = 'fetch-specialty',
  FETCH_SPECIALTY_LIST = 'fetch-specialty-list',
  FETCH_STATE = 'fetch-state',
  FETCH_TYPE_OF_LINK = 'fetch-type-of-link',
  FIELD_0 = 'field-0',
  FIELD_AVATAR = 'field-avatar',
  FIELD_BOND_TYPE = 'field-bondType',
  FIELD_CARD_CBO = 'field-card-cbo',
  FIELD_CARD_EMAIL = 'field-card-email',
  FIELD_CBO_2 = 'field-cbo-2',
  FIELD_COUNCIL = 'field-council',
  FIELD_COUNCIL_NUMBER = 'field-council-number',
  FIELD_COUNCIL_STATE = 'field-councilState',
  FIELD_EMAIL = 'field-email',
  FIELD_FIELD_OF_WORK = 'field-field-of-work',
  FIELD_FIELD_OF_WORK_LIST = 'field-field-of-work-list',
  FIELD_FILTER = 'field-filter',
  FIELD_MAIN_IE_SPECIALTY_LIST = 'field-main-ieSpecialty-list',
  FIELD_MAIN_SPECIALTY = 'field-main-specialty',
  FIELD_MAIN_SPECIALTY_LIST = 'field-main-specialty-list',
  FIELD_NAME_MODAL = 'field-name-modal',
  FIELD_SEQ_SPECIALTY = 'field-seq-specialty',
  FIELD_SEQUENCE = 'field-sequence',
  FIELD_SPECIALTY = 'field-specialty',
  FIELD_SPECIALTY_LIST = 'field-specialty-list',
  FIELD_TAX_PAYER = 'field-tax-payer',
  FIELD_TOAST = 'field-toast',
  FIELD_TOAST_2 = 'field-toast-2',
  FIELD_TOKEN_COOPERATIVE = 'field-token-cooperative',
  FIELD_TOKEN_URGENCY = 'field-token-urgency',
  FILED_ACTION_STATUS = 'filed-action-status',
  FORM_0 = 'form-0',
  FORM_DOCTOR = 'form-doctor',
  FORM_SPECIALTY = 'form-specialty',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_CUSTOM_LIST_FIELD = 'hpms-custom-list-field',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_4 = 'input-4',
  INPUT_FILTER = 'input-filter',
  INPUT_SEQUENCE = 'input-sequence',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_MODAL = 'layout-modal',
  LEGENDS = 'legends',
  LINK_ADD = 'link-add',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_2 = 'mapper-2',
  MAPPER_4 = 'mapper-4',
  MAPPER_10 = 'mapper-10',
  MAPPER_CBO = 'mapper-cbo',
  MAPPER_COUNSEL = 'mapper-counsel',
  MAPPER_LINK = 'mapper-link',
  MAPPER_LIST = 'mapper-list',
  MAPPER_SPECIALTY = 'mapper-specialty',
  MAPPER_SPECIALTY_LIST = 'mapper-specialty-list',
  MAPPER_STATE = 'mapper-state',
  MODAL_ADD_NEW = 'modal-add-new',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_ADD = 'panel-add',
  PANEL_ADD_BUTTOM = 'panel-add-buttom',
  PANEL_CLINICAL_STAFF = 'panel-clinical-staff',
  PANEL_LOCATOR = 'panel-locator',
  PANEL_MODAL = 'panel-modal',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_SAVE = 'panel-save',
  PANEL_SPECIALTY = 'panel-specialty',
  PANEL_SPECIALTY_LIST = 'panel-specialty-list',
  PANEL_SPECIALTY_TITLE = 'panel-specialty-title',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_CBO = 'text-cbo',
  TEXT_COUNSEL = 'text-counsel',
  TEXT_IE_SPECIALTY = 'text-ieSpecialty',
  TEXT_LINK = 'text-link',
  TEXT_LIST = 'text-list',
  TEXT_MAIN_LIST = 'text-main-list',
  TEXT_SPECIALTY = 'text-specialty',
  TEXT_SPECIALTY_LIST = 'text-specialty-list',
  TEXT_STATE = 'text-state',
  TEXT_TITLE = 'text-title',
  TOAST_NOTIFICATION = 'toast-notification',
  TOAST_NOTIFICATION_2 = 'toast-notification-2',
  TOAST_PENDENCIES = 'toast-pendencies',
  TOKEN_0 = 'token-0',
  TOKEN_1 = 'token-1',
  UNBOXED_AUTOCOMPLETE_CBO = 'unboxed-autocomplete-cbo',
  UNBOXED_AUTOCOMPLETE_COUNSEL = 'unboxed-autocomplete-counsel',
  UNBOXED_AUTOCOMPLETE_STATE = 'unboxed-autocomplete-state',
  UNBOXED_FIELD_OF_WORK = 'unboxed-field-of-work',
  UNBOXED_FIELD_OF_WORK_LIST = 'unboxed-field-of-work-list',
  UNBOXED_SPECIALTY = 'unboxed-specialty',
  UNBOXED_SPECIALTY_LIST = 'unboxed-specialty-list',
  UNBOXED_TYPE_OF_LINK = 'unboxed-type-of-link',
}
export { AccreditationClinicalStaffAliases };
